import React from 'react'
import { Grid, Title } from '@mantine/core'
import CardsContainer from 'components/UI/Containers/CardsContainer/CardsContainer'
import StoryCard from 'components/UI/Cards/StoryCard/StoryCard'

const ContentTypeDocument = ({ data, referencedPosts }) => {
    return (
        <Grid>
            <Grid.Col span={9}>
                {data.links[0].url.split('/').pop().split('.').pop() ===
                'pdf' ? (
                    <>
                        <iframe
                            title='PDF Viewer'
                            src={data.links[0].url}
                            width='100%'
                            height='720px'
                            frameborder='0'
                            style={{
                                overflow: 'hidden',
                                borderRadius: '.25rem',
                            }}
                        />
                    </>
                ) : (
                    <video width='100%' height='100%' controls>
                        <source src={data.links[0].url} type='video/mp4' />
                        Your browser does not support the video tag.
                    </video>
                )}
            </Grid.Col>
            <Grid.Col span={3}>
                <Title
                    c='darkGrey.0'
                    order={3}
                    sx={(theme) => ({
                        borderBottomColor: theme.colors.purple[1],
                        borderBottomWidth: '2px',
                        borderBottomStyle: 'solid',
                    })}
                >
                    {!referencedPosts
                        ? 'No existen publicaciones relacionadas con este articulo'
                        : 'Publicaciones relacionadas'}
                </Title>
                {referencedPosts && (
                    <CardsContainer
                        aspectRatio='16/9'
                        cols={1}
                        component={<StoryCard />}
                        items={referencedPosts}
                    />
                )}
            </Grid.Col>
        </Grid>
    )
}
export default ContentTypeDocument
